import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import OfferBox from "./component";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OfferBox);
